var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlockchainIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 171,
    viewBox: "0 0 194 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_246",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 194,
    height: 171
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 171,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_246)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_246)",
    filter: "url(#filter0_ddd_65_246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.8096 63.127L85.512 71.4673V88.1478L99.8096 96.4881L114.107 88.1478V71.4673L99.8096 63.127ZM107.039 72.8494L99.7477 77.1005L92.5178 72.8827L99.8096 68.6316L107.039 72.8494ZM90.2302 77.0529L97.3028 81.1801V89.5204L90.2302 85.3979V77.0529ZM102.021 89.6967V81.2754L109.389 76.9766V85.3979L102.021 89.6967ZM56.9168 25L42.6191 33.3403V50.0208L56.9168 58.3611L71.2144 50.0208V33.3403L56.9168 25ZM64.1466 34.7224L56.8548 38.9735L49.625 34.7557L56.9168 30.5046L64.1466 34.7224ZM47.3374 38.9211L54.4099 43.0484V51.3886L47.3374 47.2757V38.9211ZM59.1281 51.565V43.1484L66.4962 38.8496V47.2709L59.1281 51.565ZM56.9168 106.02L42.6191 114.36V131.041L56.9168 139.381L71.2144 131.041V114.36L56.9168 106.02ZM64.1466 115.742L56.8548 119.993L49.625 115.776L56.9168 111.524L64.1466 115.742ZM47.3374 119.946L54.4099 124.073V132.413L47.3374 128.296V119.946ZM59.1281 132.59V124.168L66.4962 119.869V128.291L59.1281 132.59ZM142.702 25L128.405 33.3403V50.0208L142.702 58.3611L157 50.0208V33.3403L142.702 25ZM149.932 34.7224L142.641 38.9735L135.411 34.7557L142.702 30.5046L149.932 34.7224ZM133.123 38.9259L140.196 43.0531V51.3934L133.123 47.2709V38.9259ZM144.914 51.5697V43.1484L152.282 38.8496V47.2709L144.914 51.5697ZM142.702 106.02L128.405 114.36V131.041L142.702 139.381L157 131.041V114.36L142.702 106.02ZM149.932 115.742L142.641 119.993L135.411 115.776L142.702 111.524L149.932 115.742ZM133.123 119.946L140.196 124.073V132.413L133.123 128.291V119.946ZM144.914 132.59V124.168L152.282 119.869V128.291L144.914 132.59ZM85.512 39.2976H114.107V44.0635H85.512V39.2976ZM85.512 120.317H114.107V125.083H85.512V120.317ZM59.2997 67.8929V96.4881H54.5338V67.8929H59.2997ZM77.3766 67.0731L67.2682 56.9647L70.6377 53.5952L80.7461 63.6989L77.3766 67.0731ZM118.873 64.5234L128.982 54.415L132.351 57.7844L122.243 67.8929L118.873 64.5234ZM81.3562 95.9114L71.2477 106.02L67.8783 102.65L77.9867 92.5419L81.3562 95.9114ZM123.062 92.337L133.171 102.445L129.801 105.815L119.693 95.7065L123.062 92.337ZM145.085 67.8929V96.4881H140.32V67.8929H145.085Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.02,
    clipPath: "url(#clip1_65_246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.3819 57.588L78.7864 68.4353V90.13L97.3819 100.977L115.977 90.13V68.4353L97.3819 57.588ZM106.785 70.2329L97.3014 75.7619L87.8982 70.2763L97.3819 64.7472L106.785 70.2329ZM84.923 75.7L94.1215 81.0678V91.9152L84.923 86.5535V75.7ZM100.258 92.1446V81.1918L109.841 75.6008V86.5535L100.258 92.1446ZM41.5955 8L23 18.8474V40.5421L41.5955 51.3895L60.191 40.5421V18.8474L41.5955 8ZM50.9986 20.6449L41.5149 26.174L32.1118 20.6883L41.5955 15.1593L50.9986 20.6449ZM29.1365 26.1058L38.3351 31.4737V42.3211L29.1365 36.9718V26.1058ZM44.4716 42.5504V31.6039L54.0545 26.0128V36.9656L44.4716 42.5504ZM41.5955 113.374L23 124.222V145.916L41.5955 156.764L60.191 145.916V124.222L41.5955 113.374ZM50.9986 126.019L41.5149 131.548L32.1118 126.063L41.5955 120.534L50.9986 126.019ZM29.1365 131.486L38.3351 136.854V147.702L29.1365 142.346V131.486ZM44.4716 147.931V136.978L54.0545 131.387V142.34L44.4716 147.931ZM153.168 8L134.573 18.8474V40.5421L153.168 51.3895L171.764 40.5421V18.8474L153.168 8ZM162.571 20.6449L153.088 26.174L143.685 20.6883L153.168 15.1593L162.571 20.6449ZM140.709 26.112L149.908 31.4799V42.3273L140.709 36.9656V26.112ZM156.044 42.5566V31.6039L165.627 26.0128V36.9656L156.044 42.5566ZM153.168 113.374L134.573 124.222V145.916L153.168 156.764L171.764 145.916V124.222L153.168 113.374ZM162.571 126.019L153.088 131.548L143.685 126.063L153.168 120.534L162.571 126.019ZM140.709 131.486L149.908 136.854V147.702L140.709 142.34V131.486ZM156.044 147.931V136.978L165.627 131.387V142.34L156.044 147.931ZM78.7864 26.5955H115.977V32.794H78.7864V26.5955ZM78.7864 131.97H115.977V138.168H78.7864V131.97ZM44.6947 63.7864V100.977H38.4962V63.7864H44.6947ZM68.2056 62.7203L55.0586 49.5733L59.4409 45.191L72.588 58.3318L68.2056 62.7203ZM122.176 59.4041L135.323 46.2571L139.705 50.6394L126.558 63.7864L122.176 59.4041ZM73.3814 100.227L60.2344 113.374L55.852 108.992L68.999 95.8451L73.3814 100.227ZM127.624 95.5785L140.771 108.726L136.389 113.108L123.242 99.9609L127.624 95.5785ZM156.268 63.7864V100.977H150.069V63.7864H156.268Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_65_246",
    x: 13.7951,
    y: -3.824,
    width: 172.029,
    height: 172.029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.05886
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.482353 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_65_246"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.11771
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.482353 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_65_246",
    result: "effect2_dropShadow_65_246"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.412
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.482353 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_65_246",
    result: "effect3_dropShadow_65_246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_65_246",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.381,
    height: 114.381,
    fill: "white",
    transform: "translate(42.6191 25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_65_246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148.764,
    height: 148.764,
    fill: "white",
    transform: "translate(23 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainIcon);
export default __webpack_public_path__ + "static/media/blockchain-icon.6ca5bda5096b8c15006555f656bb6fba.svg";
export { ForwardRef as ReactComponent };